import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import type { PaymentPlan } from "./usePaymentPlans";

export const usePaymentPlanByIri = (iri?: string | null) => {
    return useQuery<PaymentPlan | null>(
        ["payment-plan", iri],
        async () => {
            if (!iri) return null;
            const response = await loggedInApiCall.get(iri);
            return response.data as PaymentPlan;
        },
        {
            enabled: Boolean(iri),
            staleTime: 300000,
            retry: 1,
        },
    );
};
